export default __webpack_public_path__ + "static/media/DISENOPORTARROLLOS.890d4558.webp";